<template>
    <div class="ferry-passengers" v-if="product.Pax.length > 0">
        <Passenger
            v-for="(pax, index) in product.Pax"
            :product="product"
            :key="index"
            :index="index"
            :pax="pax" />
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { FerryProduct } from '@/api/Cart/cart.interfaces';
    import Passenger from '../Passenger/Passenger.vue';

    export default defineComponent({
        name: 'FerryModalDetailsPassengers',
        components: { Passenger },
        props: {
            product: {
                type: Object as PropType<FerryProduct>,
                required: true,
            },
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Passengers';
</style>
